import { render, staticRenderFns } from "./expand.vue?vue&type=template&id=d9960bb8&"
import script from "./expand.vue?vue&type=script&lang=ts&"
export * from "./expand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports